import { requestListConstants } from './request-list.constants';

const ps = JSON.parse(localStorage.getItem('dspxPageSize'));

const defaultState = {
	dataFetching: false,
	recordsRequest: undefined,
	attachmentsRequest: undefined,
	selectedRequests: [],
	selectedRequestsData: [],
	selected: undefined,
	pageSize: ps ? ps : 10,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case requestListConstants.SET_SELECTED_ROWS: {           
			return {
				...state,
				selectedRequests: action.payload.map((item) => item.id),
				selectedRequestsData: action.payload, 
			}
		}
		case requestListConstants.SET_SELECTED_ROW: {            
			return {
				...state,
				selected: action.payload,
			}
		}
		case requestListConstants.SET_PAGE_SIZE: {            
			return {
				...state,
				pageSize: action.payload,
			}
		}
		case requestListConstants.SET_RECORDS_REQUEST: {
			return {
				...state,
				recordsRequest: action.payload,
			}
		}
		case requestListConstants.SET_ATTACHMENTS_REQUEST: {
			return {
				...state,
				attachmentsRequest: action.payload,
			}
		}
		case requestListConstants.RETRIEVE_LAST_STATE: {
			return {
				...state,
				...action.payload,
			}
		}
		default:
			return state;
	}
}